import { getEnvironmentConfig, getEnvVariableDefault } from '../configHelper.js';
const definition = {
    base: {
        apiUrl: getEnvVariableDefault('EXPERTS_COCKPIT_API_URL', ''),
        clientId: getEnvVariableDefault('EXPERTS_COCKPIT_API_CLIENT_ID', ''),
        clientSecret: getEnvVariableDefault('EXPERTS_COCKPIT_API_CLIENT_SECRET', ''),
    },
    local: {
        apiUrl: 'http://3.68.116.244',
        clientId: 'default.admin@burda-forward.it',
        clientSecret: 'QYDE72rbsKAi8DjOmSxqPGwg5PLY8TRi',
    },
    local_k8s: {
        apiUrl: 'http://3.68.116.244',
        clientId: 'default.admin@burda-forward.it',
        clientSecret: 'QYDE72rbsKAi8DjOmSxqPGwg5PLY8TRi',
    },
};
export const expertsCockpitConfig = () => getEnvironmentConfig(definition);
//# sourceMappingURL=experts-cockpit.config.js.map